import Reportlayout from "../components/Reportlayout"
import SEO from "../components/seo"
import classnames from "classnames"
import React, { useState, useRef, useEffect } from "react"
import Bobbles from "../images/bobbles.svg"
import Particles from "react-particles-js"

function NotFoundPage() {
  return (
    <div style={{ backgroundColor: "#000" }}>
      {" "}
      <Particles
        height={"100vh"}
        params={{
          particles: {
            number: {
              value: 50,
            },
            size: {
              value: 3,
            },
          },
          interactivity: {
            events: {
              onhover: {
                enable: true,
                mode: "repulse",
              },
            },
          },
        }}
      />{" "}
      <div
        style={{
          position: "fixed",
          top: 0,
          color: "#whitesmoke",
          marginTop: "10%",
          textAlign: "center",
          marginLeft: "40%",
          marginRight: "40%",
        }}
      >
        <b
          style={{
            textAlign: "center",
            fontSize: "40px",
          }}
        >
          <div style={{ color: "#ff8bd8" }}>404</div>
        </b>{" "}
        Nothing to see here
        <Bobbles />
      </div>
    </div>
  )
}
export default NotFoundPage
